const TermsOfService = () => {
  return (
    <div className='bg-white w-full max-w-4xl flex flex-col'>
      <div className='flex justify-start p-6 pb-0'>
        <p className='text-sm font-semibold text-gray-700'>
          Last Updated: 11-12-2025
        </p>
      </div>
      <div className='flex-1 overflow-y-auto p-6'>
        <div className='max-w-none prose prose-gray'>
          <div className='mb-5 border-b-2 border-gray-200 pb-3'>
            <p className='text-sm text-gray-700 mb-1 leading-relaxed text-left font-bold'>
              These Terms & Conditions (“Terms”) govern your access and use of
              our application (“App”, “Service”, “we”, “us”, “our”).
            </p>
            <p className='text-sm text-gray-700 leading-relaxed text-left'>
              By using our app, you agree to these terms.
            </p>
          </div>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              1. Acceptance of Terms
            </h2>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              By downloading, installing, or using the App, you:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>Accept these Terms</li>
              <li className='leading-relaxed'>
                Agree to comply with all applicable laws (including DPDP Act
                2023)
              </li>
            </ul>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              If you do not agree, please stop using the App immediately.
            </p>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              2. User Account & Registration
            </h2>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              To use certain features, you must provide:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>
                <strong>Email ID</strong> (for login and communication)
              </li>
              <li className='leading-relaxed'>
                <strong>City</strong> (for user statistics only)
              </li>
            </ul>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              You agree to:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>Provide accurate details</li>
              <li className='leading-relaxed'>
                Not create multiple fake accounts
              </li>
              <li className='leading-relaxed'>
                Maintain the confidentiality of your account
              </li>
            </ul>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              You are responsible for all activity under your account.
            </p>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              3. Payments & Billing
            </h2>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              We accept All Kinds of payments Including UPI/QR Code Scan & Pay,
              Credit/Debit etc.
            </p>
            <h2 className='text-sm font-bold text-gray-900 mb-4 text-left'>
              3.1 Payment Confirmation
            </h2>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>
                After payment, you will receive a confirmation via email.
              </li>
              <li className='leading-relaxed'>
                You must ensure the email ID provided is valid.
              </li>
            </ul>
            <h2 className='text-sm font-bold text-gray-900 mb-4 text-left'>
              3.2 No Sensitive Info Collected
            </h2>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              We <strong>do NOT</strong> collect:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>UPI PIN</li>
              <li className='leading-relaxed'>Bank account details</li>
              <li className='leading-relaxed'>
                We use <strong>third-party payment gateways</strong> to process
                all payments made through our application. These external
                payment processors collect and process your payment details
                directly, and we{' '}
                <strong>
                  do not store or have access to your full payment information
                </strong>{' '}
                (such as card numbers, UPI PIN, or bank credentials).
              </li>
            </ul>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              All transactions occur through your chosen UPI app’s secure
              environment.
            </p>
            <h2 className='text-sm font-bold text-gray-900 mb-4 text-left'>
              3.3 Failed or Pending Payments
            </h2>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              If your payment fails or remains pending, access to paid features
              may be withheld until confirmation.
            </p>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              4. Use of the App
            </h2>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              You agree <strong>NOT</strong> to:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>
                Engage in misuse, hacking, reverse engineering, or unauthorized
                access
              </li>
              <li className='leading-relaxed'>
                Upload harmful content (viruses, malicious code, etc.)
              </li>
              <li className='leading-relaxed'>
                Use the App for illegal activities
              </li>
              <li className='leading-relaxed'>
                Violate intellectual property rights
              </li>
              <li className='leading-relaxed'>
                Share false payment screenshots or details
              </li>
            </ul>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              We may suspend or terminate your access without prior notice for
              violations.
            </p>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              5. Data Collection & Privacy
            </h2>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              We collect:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>
                Email ID (for login & communication)
              </li>
              <li className='leading-relaxed'>
                City name (for user count only)
              </li>
              <li className='leading-relaxed'>
                Payment reference details (UPI transaction ID)
              </li>
            </ul>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              Our data usage follows the{' '}
              <strong>
                Digital Personal Data Protection Act (DPDP Act) 2023.
              </strong>
            </p>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              Refer to our <strong>Privacy Policy</strong> for full details.
            </p>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              6. Subscriptions / Paid Features
            </h2>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              If your App includes paid features:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>
                Access is granted only after successful payment
              </li>
              <li className='leading-relaxed'>
                Duration or validity will be mentioned separately
              </li>
              <li className='leading-relaxed'>
                Prices may be updated without prior notice
              </li>
            </ul>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              7. Refund & Cancellation Policy
            </h2>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>
                All payments are <strong>non-refundable</strong> unless a
                duplicate/incorrect charge occurs
              </li>
              <li className='leading-relaxed'>
                Refunds (if approved) will be processed within{' '}
                <strong>7–10 working days</strong>
              </li>
              <li className='leading-relaxed'>
                Users must provide valid proof (e.g., transaction reference)
              </li>
            </ul>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              A detailed Refund Policy has been provided separately.
            </p>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              8. Intellectual Property
            </h2>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              All content in the App, including:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>Design</li>
              <li className='leading-relaxed'>Text</li>
              <li className='leading-relaxed'>Images</li>
              <li className='leading-relaxed'>Code</li>
              <li className='leading-relaxed'>Features</li>
            </ul>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              is the property of <strong>Vidura Infotech Llp</strong>.
            </p>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              Users cannot copy, redistribute, modify, or use content without
              written permission.
            </p>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              9. Service Availability & Updates
            </h2>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>
                We may update, modify, or discontinue features without notice
              </li>
              <li className='leading-relaxed'>
                The App may experience downtime due to maintenance or technical
                issues
              </li>
              <li className='leading-relaxed'>
                We are not liable for service interruptions
              </li>
            </ul>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              10. Limitation of Liability
            </h2>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              We are <strong>not responsible</strong> for:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>
                UPI/payment failures caused by banks or third-party apps
              </li>
              <li className='leading-relaxed'>
                Data loss due to technical issues
              </li>
              <li className='leading-relaxed'>
                Damages arising from misuse of the App
              </li>
              <li className='leading-relaxed'>
                Losses caused by inaccurate information entered by the user
              </li>
            </ul>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              You use the App at your own risk.
            </p>
          </section>

          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              11. Termination
            </h2>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              We may suspend or terminate your access if:
            </p>
            <ul className='text-sm list-disc list-inside text-gray-700 mb-4 space-y-2 ml-4 text-left'>
              <li className='leading-relaxed'>You violate these Terms</li>
              <li className='leading-relaxed'>
                Provide fraudulent information
              </li>
              <li className='leading-relaxed'>Abuse or misuse the App</li>
            </ul>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              You may stop using the App at any time.
            </p>
          </section>
          <section className='mb-5 border-b-2 border-gray-200 pb-3'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              12. Governing Law (India)
            </h2>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              These Terms are governed by the laws of <strong>India</strong>.
            </p>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              Any disputes will be handled under the jurisdiction of courts in
              <strong>Hyderabad</strong>.
            </p>
          </section>
          <section className='mb-5'>
            <h2 className='text-base font-bold text-gray-900 mb-4 text-left'>
              13. Contact Us
            </h2>
            <p className='text-sm text-gray-700 mb-4 leading-relaxed text-left'>
              For support, queries, or complaints:
            </p>
            <div className='bg-gray-50 p-4 rounded-lg text-left'>
              <p className='text-sm text-gray-700 leading-relaxed'>
                📧 support@vidurainfotech.com
                <br />
                🏢 Vidura Infotech Llp
                <br />
                📍 Hyderabad, India
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
